import React, { Component } from 'react'
import { connect } from 'react-redux';

import classnames from "classnames";
import Button from './../shared/Button/index';

import styles from './../../styles/perfect_essay.styl';
import baseStyles from 'custom/base.styl';
import success from './../../img/success@3x.png';

import { profileUpdateStages } from "../../store/profile/actions";

class EssayGeneralChemistry extends Component {
  constructor(props) {
    super(props)

    this.state = {
      curStep: 'step1',
    }

    this.onStepClick = this.onStepClick.bind(this)
    this.onComplete = this.onComplete.bind(this)
    this.onStageNext = this.onStageNext.bind(this)
  }

  onStepClick(e) {
    const newStep = e.target.dataset.step;
    // let offsetTop  = e.target.getBoundingClientRect().top;

    this.setState({
      curStep: newStep,
    });
    // e.target.scrollIntoView({ behavior: "smooth" });
    const el = document.getElementById(newStep);
    el.scrollIntoView({ behavior: "smooth" });


    // this.setState({
    //   curStep: newStep,
    // }, () => window.scrollTo({ top: offsetTop, behavior: 'smooth' }));
  }

  onComplete() {
    this.setState({
      curStep: 'finish',
    }, () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }

  onStageNext() {
    const { nextStage } = this.props;
    nextStage();
    return;
  }

  render() {
    const { curStep } = this.state;

    return (
      <div>
        {/* page-1 */}
        <div className={classnames(styles.perfect_essay)}>

          <div className={classnames(styles.comment_finish, { [styles.active]: curStep === 'finish' })}>
            <img src={success} alt="success" width="100px" />
            <h3>Thank you for completing <br /> the first essay</h3>
						<p>There’s only one test essay left <br /> before you join us as a writer and <br /> start working with real orders. <br /> Show there all your academic <br /> knowledge and writing skills, as we <br /> will check it thoroughly to decide <br /> whether you have passed the <br /> probation.</p>
            <Button onClick={(e) => this.onStageNext(e)} block >Begin the last essay</Button>
          </div>

          <div className={styles.catchword}>Student’s Last Name 1</div>

          <div className={classnames(styles.highlighting, styles.highlighting_type1, { [styles.active]: curStep === 'step1' })} data-step="step1" id="step1">

            <div className={styles.highlighting_content}>
              <header>
                Student’s Name <br />
                Professor’s Name <br />
                Subject <br />
                DD MM YYYY <br />
              </header>

              <div className={styles.center}>Atom and Atomic Theory</div>

              <div className={classnames(styles.comment)}>
                <ul>
                  <li>The paper follows the requirements of the MLA formatting style.</li>
                  <li>No personal information is included.</li>
                  <li>Please download a template to avoid mistakes and spend less time on formatting.</li>
                </ul>
                <div className={classnames(styles.btn_wrap, baseStyles.flex_right)}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step2">NEXT&rarr;&nbsp;</button>
                </div>
              </div>

            </div>
          </div>

          <div className={classnames(styles.highlighting, styles.highlighting_type2, { [styles.active]: curStep === 'step2' })} data-step="step2" id="step2">
            <div className={styles.highlighting_content}>
              <p>The discovery of atom, has made a great impact on the development of science, evoking further people’s interest and significant contributions made by John Thompson, Ernest Rutherford, and Antoine Becquerel.</p>

              <div className={styles.comment}>
                <ul>
                  <li>Content:  The instructions are followed: the paper answers the required question “How the discovery helped the development of the science” explicitly. </li>
                  <li>Structure: The introduction contains an arguable thesis statement that addresses the topic.</li>
                  <li>The word count of the introduction is 10%.</li>
                </ul>
                <div className={styles.btn_wrap}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step1">&larr;&nbsp;PREVIOUS</button>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step3">NEXT&rarr;&nbsp;</button>
                </div>
              </div>
            </div>
          </div>

          <div className={classnames(styles.highlighting, styles.highlighting_type3, { [styles.active]: curStep === 'step3' })} data-step="step3" id="step3">
            <div className={styles.highlighting_content}>
              <p>In physics, atomic theory is a scientific model of the nature of matter, which declares that this very matter is composed of discrete units called atoms, i.e. the smallest particles of matter. The existence of atoms was assumed by ancient Greeks. The word ‘atom’ was invented by the ancient Greek philosophers Leucippus and Democritus. Nevertheless, the idea that matter consists of discrete units originated in theological theories rather than in experimentation (Pullman, and Reisinger 21). The philosophers could not prove their theories in practice but left a great legacy for the future generations.</p>
              <div className={styles.comment}>
                <ul>
                  <li>Content: The paragraph discusses one idea that is a part of the thesis statement.</li>
                  <li>Structure: The paragraph begins with a topic sentence that explains the main idea. It is followed by the analysis supported with outside information cited in MLA. </li>
                  <li>Language: No personal pronouns, phrasal verbs, contractions, idioms, colloquial language, rhetorical questions are used.</li>
                </ul>
                <div className={styles.btn_wrap}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step2">&larr;&nbsp;PREVIOUS</button>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step4">NEXT&rarr;&nbsp;</button>
                </div>
              </div>
            </div>
          </div>

          <div className={classnames(styles.highlighting, styles.highlighting_type4, { [styles.active]: curStep === 'step4' })} data-step="step4" id="step4">
            <div className={styles.highlighting_content}>
              <p>Atoms were thought to be the smallest possible division of matter until the nineteenth century that is considered the peak of the scientific discoveries. In 1897 John Thomson discovered the electron through his work on cathode rays. He found that atoms “contain the negatively charged electrons” (Thomson 297). The experiments of Ernest Rutherford showed that every atom has a nucleus, which is extremely small in comparison with the atom’s size but contains almost its entire mass (Rutherford 382). Apart from that, Antoine Becquerel discovered that atoms of some elements can spontaneously lose particles, becoming atoms of different elements. This phenomenon is now known as radiation and is widely used in practice (Rutherford 383). As a result, the discovery of atom and atom theory serves as a trigger for the further notable discoveries of the nineteenth century that contributed to the development of science and people’s everyday life.</p>
              <div className={styles.comment}>
                <ul>
                  <li>Content: The paragraph is devoted to one idea that relates to the thesis and is supported with an example from the outside source.</li>
                  <li>Plagiarism: Direct quotations do not exceed 10% of the required word count. No unsupported claims are present in the paper.</li>
                  <li>Structure: The paragraph contains at least 3 sentences and does not exceed 200 words. </li>
                </ul>
                <div className={styles.btn_wrap}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step3">&larr;&nbsp;PREVIOUS</button>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step5">NEXT&rarr;&nbsp;</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* page-2 */}
        <div className={classnames(styles.perfect_essay)}>
          <div className={styles.catchword}>Student’s Last Name 2</div>

          <div className={classnames(styles.highlighting, styles.highlighting_type1, { [styles.active]: curStep === 'step5' })} data-step="step5" id="step5">
            <div className={styles.highlighting_content}>
              <p>To conclude, the ancient Greek philosophers’ discovery of the atom helped the development of the science by triggering interest of such scholars, as John Thompson, Ernest Rutherford, and Antoine Becquerel.</p>
              <div className={classnames(styles.comment, styles.comment_bottom)}>
                <ul>
                  <li>Content: The Conclusion contains no new information and restates the thesis. </li>
                  <li>Structure: The word count of the Conclusion is 10% of the required word count (1 page = 300 words). It begins with a linking word that contributes to the logical flow of the essay.</li>
                </ul>
                <div className={styles.btn_wrap}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step4">&larr;&nbsp;PREVIOUS</button>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step6">NEXT&rarr;&nbsp;</button>
                </div>
              </div>
            </div>
          </div>

        </div>

        {/* page-3 */}
        <div className={classnames(styles.perfect_essay)}>
          <div className={styles.catchword}>Student’s Last Name 2</div>

          <div className={classnames(styles.highlighting, styles.highlighting_type2, { [styles.active]: curStep === 'step6' })} data-step="step6" id="step6">
            <div className={styles.highlighting_content}>

              <div className={styles.center}>Works Cited</div>

              <div>Thomson, J. J. "XL. Cathode Rays". <i>The London, Edinburgh, And Dublin Philosophical</i> </div>
              <p><i>Magazine And Journal Of Science,</i> vol 44, no. 269, 1897, pp. 293-316. <i>Informa UK </i></p>
              <p><i>Limited,</i> doi:10.1080/14786449708621070. Accessed 27 June 2018.</p>

              <div>Pullman, Bernard, and Axel Reisinger. <i> The Atom In The History Of Human Thought.</i> Oxford </div>
              <p>University Press, 2011.</p>

              <div>Rutherford, Ernest. "The Scattering Of Α And Β Particles By Matter And The Structure </div>
              <p>Of The Atom". <i>Philosophical Magazine</i>, vol 92, no. 4, 2012, pp. 379-398. <i>Informa UK</i> </p>
              <p><i>Limited</i>, doi:10.1080/14786435.2011.617037. Accessed 27 June 2018.</p>


              <div className={classnames(styles.comment)}>
                <ul>
                  <li>The minimum requirement to include 1 source per 1 page (300 words) is met.</li>
                  <li>The incorporated source is reliable, relevant (published within the last 5-7 years), and to the topic.</li>
                  <li>Works Cited page is formatted according to the requirements of the MLA formatting style. </li>
                  <li>In case the paper contains more than one source, the list should be alphabetized.</li>
                </ul>
                <div className={styles.btn_wrap}>
                  <button onClick={(e) => this.onStepClick(e)} className={styles.btn} data-step="step5">&larr;&nbsp;PREVIOUS</button>
                  <Button onClick={(e) => this.onComplete(e)} className={styles.btn_finish} light>Finish</Button>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  nextStage: () => dispatch(profileUpdateStages()),
});

export default connect(null, mapDispatchToProps)(EssayGeneralChemistry);




// WEBPACK FOOTER //
// ./src/components/PerfectEssay/EssayGeneralChemistry.js